import React from 'react';
import { Box, Container, Typography, Grid } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const About = () => {
  const theme = useTheme();

  return (
    <Box
      id="about"
      sx={{
        pt: { xs: 10, md: 12 },
        pb: { xs: 8, md: 12 },
        backgroundColor: theme.palette.background.default,
      }}
    >
      <Container maxWidth="lg" sx={{ px: { xs: 3, sm: 4, md: 6 } }}>
        <Typography
          variant="h2"
          component="h2"
          sx={{
            textAlign: 'center',
            mb: { xs: 4, md: 6 },
            color: theme.palette.text.primary,
            fontWeight: 700,
            fontSize: { xs: '2rem', sm: '2.25rem', md: '2.5rem' },
          }}
        >
          About Us
        </Typography>
        <Grid container spacing={{ xs: 4, md: 6 }} alignItems="center">
          <Grid item xs={12} md={6}>
            <Box
              component="img"
              src="/family.jpg"
              alt="JOCAST Machining Team"
              sx={{
                width: '100%',
                height: 'auto',
                objectFit: 'cover',
                borderRadius: 0,
                boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
              }}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <Typography
              variant="body1"
              sx={{
                mb: 3,
                fontSize: { xs: '1rem', md: '1.15rem' },
                lineHeight: 1.8,
                color: theme.palette.text.secondary,
              }}
            >
              JOCAST Machining is a proud family-run business with over 20 years
              of expertise in machining turned parts. Since our establishment as an
              LLC in August of 2024, we have dedicated ourselves to quick quote
              turnarounds and working closely with our clients to solve their unique
              challenges or demand for parts.
            </Typography>
            <Typography
              variant="body1"
              sx={{
                fontSize: { xs: '1rem', md: '1.15rem' },
                lineHeight: 1.8,
                color: theme.palette.text.secondary,
              }}
            >
              Our goal is to build relationships with customers to create reliable
              machining solutions for their projects.
            </Typography>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default About;
